import styled from '@emotion/styled/macro';

export const Container = styled.div`
  padding: 30px;
  background-color: #f5f6f8;
  min-height: 100vh;
`;

export const ContentWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-top: 20px;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #444;
  margin-bottom: 20px;
`;

export const HeaderActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Button = styled.button`
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: #3b78e7;
  }
`;

export const ContentContainerQuestionnaire = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 20px;
`;

export const QuestionnaireList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const QuestionnaireItem = styled.div`
  border-radius: 4px;
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  border-left: ${(props) => `4px solid ${props.borderColor}`};

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const QuestionnaireTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
`;

export const QuestionnaireDescription = styled.p`
  font-size: 12px;
  color: #777;
`;

export const QuestionnaireDetail = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 4px;
  padding: 20px;
  background-color: white;
`;

export const DetailTitle = styled.h2`
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
`;

export const DetailSection = styled.div`
  margin-bottom: 20px;
`;

export const DetailLabel = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
`;

export const DetailValue = styled.div`
  font-size: 14px;
  color: #333;
  background-color: #f9f9f9;
  padding: 8px;
  border-radius: 4px;
`;

export const QuestionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
`;

export const Question = styled.div`
  display: flex;
  gap: 10px;
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 4px;
`;

export const QuestionNumber = styled.div`
  font-weight: bold;
  color: #333;
`;

export const QuestionText = styled.div`
  color: #333;
`;
